import { render, staticRenderFns } from "./nameFieldLabel.vue?vue&type=template&id=edeffa4c"
import script from "./nameFieldLabel.vue?vue&type=script&lang=js"
export * from "./nameFieldLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports